import React, { useEffect, useState } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { sizesMap, sizesFieldsNamesMap } from './utils';
import * as _ from 'lodash';

export default function ParamsFilter({ setParamsFilter, paramsFilter }) {
    const [currentParamsFilter, setCurrentParamsFilter] = useState(paramsFilter);

    useEffect(() => {
        setCurrentParamsFilter(paramsFilter);
    }, [paramsFilter]);

    const handleChange = (_e, _i, values) => {
        const lastKey = Object.keys(values[values.length - 1])[0];
        const currentKeys = currentParamsFilter.map(c => Object.keys(c)[0]);

        if (currentKeys.includes(lastKey)) {
            setParamsFilter(values.filter(v => Object.keys(v)[0] !== lastKey));
        } else {
            setParamsFilter(values);
        }
    };

    const menuItems = () => Object.entries(_.omit(sizesMap, ['grouppedByHatches', 'grouppedByHolds'])).map(size => (
        <MenuItem
            key={size[0]}
            insetChildren
            checked={currentParamsFilter.some(c => Object.keys(c)[0] === size[0])}
            value={{ [size[0]]: sizesFieldsNamesMap[size[0]] }}
            primaryText={size[1]}
            style={{ fontSize: '13px' }}
        />
    ));

    const selectionRenderer = () => {
        switch (currentParamsFilter.length) {
        case 0:
            return '';
        case 1:
            return sizesMap[Object.keys(currentParamsFilter[0])[0]];
        default:
            return `${currentParamsFilter.length} names selected`;
        }
    };

    return (
        <SelectField
            multiple
            hintText="Select size"
            value={currentParamsFilter}
            onChange={handleChange}
            selectionRenderer={selectionRenderer}
            style={{ fontSize: '13px', width: '250px' }}
        >
            {menuItems()}
        </SelectField>
    );
}



// WEBPACK FOOTER //
// ./app/components/Vessels/Composition/ParamsFilter.jsx